import React, { Component } from "react";
import { validators } from "./Validators";
import { creditScoreList, loanPurposeList, defaultVaules,stateList,sortByOfferList1 } from "./AppData";


const displayBlock = { display: 'block' };
const displayNone = { display: 'none' };

class FilterGroupContentV2 extends Component {
    constructor(props) {
        super(props);      
        
        this.handleLoanPurposeChange = this.handleLoanPurposeChange.bind(this);
        this.handleStateListChange = this.handleStateListChange.bind(this);
        this.handleCreditScoreChange = this.handleCreditScoreChange.bind(this);
        this.handleLoanAmountChange = this.handleLoanAmountChange.bind(this);
        this.handleLoanAmountMouseMove = this.handleLoanAmountMouseMove.bind(this);
        this.handleIncomeMouseMove = this.handleIncomeMouseMove.bind(this);
        this.handleIncomeChange = this.handleIncomeChange.bind(this);
        this.handleLoanTermChange = this.handleLoanTermChange.bind(this);
        this.handleLoanTermMouseMove = this.handleLoanTermMouseMove.bind(this);
        this.handleUpdateResultClick = this.handleUpdateResultClick.bind(this);
        this.handleEnterClick = this.handleEnterClick.bind(this);
        this.handleResetFilters = this.handleResetFilters.bind(this);
        this.onLoanPurposeClick = this.onLoanPurposeClick.bind(this);
        this.onCreditScoreClick = this.onCreditScoreClick.bind(this);
        this.validations = validators();
        this.currencySymbol = this.validations.getCurrencySymbolWithSpace();
        this.handleSortByChange = this.handleSortByChange.bind(this);
        this.onSortByClick = this.onSortByClick.bind(this);
        
        this.state = {
            isError: false,
            creditScore: this.props.creditScore ? this.props.creditScore : defaultVaules.creditScore,
            loanPurpose: this.props.loanPurpose ? this.props.loanPurpose : (window[this.props.rootId].loanPurpose?window[this.props.rootId].loanPurpose:defaultVaules.loanPurpose),
            lenderState: this.props.lenderState ? this.props.lenderState : (window[this.props.rootId].state?window[this.props.rootId].state:defaultVaules.state?defaultVaules.state:''),
            loanAmountDisplay:  this.validations.amountFormatting(this.props.loanAmount),
            anualIncomeDisplay: this.validations.amountFormatting(this.props.annualIncome),
            loanAmount : this.validations.isLoanTermInRange(this.props.loanAmount) ?  this.props.loanAmount : 10000,
            loanAmountHasError: false,
            loanTermHasError: false,
            anualIncomeHasError: false,
            hasErrorCssClass: 'has-error',
            filterHeader: 'Refine Results',
            filterButtonText: 'Submit',
            displayFilter: true,
            filterToggleClass: '',
            displayLoanPurposeItems: false,
            displayCreditScoreItems: false,
            value5: {
                min: parseInt(this.validations.initialValues.anualIncomeMin, 10),
                max: parseInt(this.validations.initialValues.anualIncomeMax, 10),
            },
            sliderIndexValue: 40,
            cutVal: 100000,
            largeStepAmt: 5000,
            lowerStepAmount: 1000,
            indexSize:0,
            showLoanPurpose: true,
            loanAmountValue: this.props.loanAmount,
            offsetWidth : 0,
        };
    
    }   
    
    componentDidMount() {
        this.ComputeSliderIndexSize();
        this.setState({sliderIndexValue : this.GetIndexBasedOnAmount(this.props.annualIncome)});
        const filteredCreditScore = creditScoreList.filter(lp => {
            if(this.props.creditScoreIndex) {
                return (lp.index.toLowerCase() === this.props.creditScoreIndex.toLowerCase());
            }
            return filteredCreditScore;
        });
        if(filteredCreditScore.length > 0) {
            
            this.setState({creditScore : filteredCreditScore[0].key});
            this.props.onUpdateResultClick(this.state.loanPurpose, this.state.creditScore,this.state.loanAmount, true);
        } else {
            this.setState({creditScore : this.props.creditScore });
            this.props.onUpdateResultClick(this.state.loanPurpose, this.state.creditScore,this.state.loanAmount, true);
        }
        this.setState({ showLoanPurpose : true});
    }
    componentDidUpdate() {        
        if(this.props.creditScore !== this.state.creditScore) {
            if(parseInt(this.props.creditScoreIndex, 10) > 0 && parseInt(this.props.creditScoreIndex, 10) < 5 && this.props.creditScore) {
                const filteredCreditScore = creditScoreList.filter(lp => {
                    if(this.props.creditScoreIndex) {
                        return (lp.index.toLowerCase() === this.props.creditScoreIndex.toLowerCase());
                    }
                    return filteredCreditScore;
                });
                if(filteredCreditScore.length > 0) {
                    
                    this.setState({creditScore : filteredCreditScore[0].key});
                    this.props.onUpdateResultClick(this.state.loanPurpose, this.state.creditScore,this.state.loanAmount, true);
                }
            } else {
                this.setState({ creditScore: this.props.creditScore});
            }
        }
        if(this.props.loanPurpose !== this.state.loanPurpose) {
            this.setState({ loanPurpose : this.props.loanPurpose ? this.props.loanPurpose : defaultVaules.loanPurpose });
        }
    }
    handleSortByChange(event) {
        this.props.onSortByChage(event.target.value);
    }

    onSortByClick(event) {
        this.setState((prevState) => ({ displaySortByItems: !prevState.displaySortByItems }));
    }
    ComputeSliderIndexSize(){  
        // Add the number of indexes below the cut value to the number of indexes above the cut value
        // Round down the remainder in the division operations below
        var lowIndexes = Math.ceil(((this.state.cutVal - this.validations.initialValues.anualIncomeMin)/1000)+1); //Get the number of indexes on the slider that are below the cut point, including the cut point
        var highIndexes = 0;
        if(this.validations.initialValues.anualIncomeMax > this.state.cutVal) {
            highIndexes = Math.ceil((this.validations.initialValues.anualIncomeMax - this.state.cutVal)/this.state.largeStepAmt); //Get the number of indexes above the cut point
            this.setState({ lowIndexes : lowIndexes,
                preMin : 0, preMax : (lowIndexes + highIndexes) - 1
             });
        } else {
            highIndexes = Math.ceil((this.validations.initialValues.anualIncomeMax - this.validations.initialValues.anualIncomeMin)/this.state.lowerStepAmount) + 1;
            this.setState({ indexSize :  highIndexes, lowIndexes: lowIndexes, 
                preMin : 0,preMax : highIndexes - 1 }) ;
        }
        this.setState({ indexSize : lowIndexes + highIndexes });
    }
    handleSliderChange(value){
        this.setState({ sliderIndexValue: value.target.value });
        var cutIndex = this.state.lowIndexes - 1;             
        var finalAmount;
        if(this.state.preMin !== value.target.value) {
            var indexVal = value.target.value;
            if (indexVal === 0)
                finalAmount = parseInt(this.validations.initialValues.anualIncomeMin, 10);
            else if (parseInt(indexVal, 10) === this.state.indexSize - 1) //Just indexSize if 1 based index array
                finalAmount = this.validations.initialValues.anualIncomeMax;
            else if (indexVal <= cutIndex) //round the lower amount to nearest 1000
                finalAmount = parseInt(Math.floor(this.validations.initialValues.anualIncomeMin/1000)*1000, 10)+(indexVal * this.state.lowerStepAmount);
            else // It's above the cut index
                finalAmount = parseInt(this.state.cutVal, 10) + (indexVal - cutIndex) * this.state.largeStepAmt;

            this.setState({preMin : value.target.value, displayMinAmount : finalAmount,
                value5 : {min: finalAmount, max: this.state.displayMaxAmount},
                anualIncomeDisplay : this.validations.amountFormatting(finalAmount)
             });
            //this.state.value5 = {min: finalAmount, max: this.state.displayMaxAmount};
            //this.state.anualIncomeDisplay = this.validations.amountFormatting(finalAmount);
            this.props.onIncomeChange(finalAmount, true);               
        }
    }
    GetIndexBasedOnAmount(amount) {
        var index = 0;
        if(amount < this.state.cutVal) {
            index = ((amount - this.validations.initialValues.anualIncomeMin) / this.state.lowerStepAmount);
        } else {
            amount = Math.ceil(amount/this.state.largeStepAmt) * this.state.largeStepAmt;
            this.setState({ anualIncomeDisplay : this.validations.amountFormatting(amount) });
            //this.state.anualIncomeDisplay = this.validations.amountFormatting(amount);
            index = ((amount - this.validations.initialValues.anualIncomeMin - this.state.cutVal) / this.state.largeStepAmt);
            index = index + this.state.lowIndexes;
        }
        return parseInt(index, 10);
    }
    handleResetFilters(){
        const creditScoreProps=defaultVaules.creditScore;
        const LoanPurposeProps=(window[this.props.rootId].loanPurpose?window[this.props.rootId].loanPurpose:defaultVaules.loanPurpose);

        this.setState({
            loanAmountDisplay : this.validations.amountFormatting(this.state.loanAmount),
            anualIncomeDisplay : this.validations.amountFormatting(50000),
            lenderState:'Select'
        });
       
        this.props.onIncomeChange(50000, false);
        this.props.onLoanAmountChange(this.state.loanAmount, false);
        this.props.onCreditScoreChange(defaultVaules.creditScore, false);
        this.props.onLenderStateChange('Select', false);
        this.setState({ sliderIndexValue : 40});
        this.props.onUpdateResultClick(LoanPurposeProps,creditScoreProps,this.state.loanAmountDisplay, true,this.state.lenderState);        
    }

    handleUpdateResultClick(event) {
        if (this.state.isLoanAmountRange || this.state.isLoanTermInRange || this.state.isAnualIncomeInRange || this.state.isValidZip || this.state.isLoanTermRange) {
            this.setState({ isUpdateError: true });
        } else {
            this.props.onUpdateResultClick(this.state.loanPurpose, this.state.creditScore,this.state.loanAmount, true);
            this.showFilter(!this.state.displayFilter);
            this.setState({ filterHeader: 'Refine Results', filterButtonText: 'Update Results' });
        }
    }
    handleEnterClick(event) {
        var code = event.keyCode || event.charCode;
        if (code === 13) {
            if (this.state.isLoanAmountRange || this.state.isLoanTermInRange || this.state.isAnualIncomeInRange || this.state.isValidZip || this.state.isLoanTermRange) {
                this.setState({ isUpdateError: true });
            } else {
                this.props.onUpdateResultClick(this.state.loanPurpose, this.state.creditScore);
                if(!window.mobileDevice) this.showFilter(!this.state.displayFilter);
                this.setState({ filterHeader: 'Refine Results', filterButtonText: 'Update Results' });
            }
        }
    }
    unFormatAmount(formattedValue) {
        return formattedValue !== null ? formattedValue.toString().replace(window.currencySymbol, '').replace(/,/g, '') : '';
    }

    handleIncomeChange(event) {
        var amount = this.unFormatAmount(event.target.value);
        if (this.validations.isValidInteger(amount)) {
            this.props.onIncomeChange(amount);
            this.setState({ anualIncomeDisplay: this.validations.amountFormatting(amount) });
            if (this.validations.isAnualIncomeInRange(amount)) {
                this.setState({ isAnualIncomeInRange: true, isError: true, anualIncomeHasError: true });
            }
            else { this.setState({ isAnualIncomeInRange: false, isError: false, isUpdateError: false, anualIncomeHasError: false }); }
        }
    }
    handleIncomeMouseMove(event) {
        var amount = this.unFormatAmount(event.target.value);
        if (this.validations.isValidInteger(amount)) {
            this.props.onIncomeChange(amount, true);
            this.setState({ anualIncomeDisplay: this.validations.amountFormatting(amount) });
            if (this.validations.isAnualIncomeInRange(amount)) {
                this.setState({ isAnualIncomeInRange: true, isError: true, anualIncomeHasError: true });
            }
            else { this.setState({ isAnualIncomeInRange: false, isError: false, isUpdateError: false, anualIncomeHasError: false }); }
        }
    }

    handleLoanTermChange(event) {
        if (this.validations.isValidInteger(event.target.value)) {
            this.props.onLoanTermChange(event.target.value, false);
            if (this.validations.isLoanTermInRange(event.target.value)) {
                this.setState({ isLoanTermRange: true, isError: true, loanTermHasError: true });
            }
            else { this.setState({ isLoanTermRange: false, isError: false, isUpdateError: false, loanTermHasError: false }); }
        }
    }

    handleLoanTermMouseMove(event) {
        if (this.validations.isValidInteger(event.target.value)) {
            if (this.state.isLoanAmountRange || this.state.isLoanTermInRange || this.state.isAnualIncomeInRange || this.state.isValidZip || this.state.isLoanTermRange) {
                this.setState({ isUpdateError: true });
            } else {
                this.props.onLoanTermChange(event.target.value, true);
                if(!window.mobileDevice) this.showFilter(!this.state.displayFilter);
                this.setState({ filterHeader: 'Refine Results', filterButtonText: 'Update Results' });
            }
            if (this.validations.isLoanTermInRange(event.target.value)) {
                this.setState({ isLoanTermRange: true, isError: true, loanTermHasError: true });
            }
            else { this.setState({ isLoanTermRange: false, isError: false, isUpdateError: false, loanTermHasError: false }); }
        }
    }

    handleLoanAmountChange(event) {
        
        var amount = this.unFormatAmount(event.target.value); // event.target.value.replace('$', '').replace(/,/g, '');
        if (this.validations.isValidInteger(amount, false)) {
            this.setState({ loanAmountDisplay: this.validations.amountFormatting(amount) });
            
            if (this.validations.isLoanAmountInRange(amount)) {
                this.setState({ isLoanAmountRange: true, isError: true, loanAmountHasError: true });
                
            }
            else { this.props.onLoanAmountChange(amount); 
                this.setState({ isLoanAmountRange: false, isError: false, isUpdateError: false, loanAmountHasError: false }); }
        }
    }
    handleLoanAmountValueChange(isFocus, event) { 
        var amount = this.unFormatAmount(event.target.value);
        if (this.validations.isValidInteger(amount, false)) {
            this.props.onLoanAmountChange(amount);
            this.setState({ loanAmountDisplay: amount });
            if(this.props.iframeVersion) {
                try {
                    window.parent.postMessage('ScrollToTop', `${window.iframeHost}`);
                } catch (error) {
                    console.log(error);
                }
            } 
            else {
                // window.scroll(0, 0);
            }
        }
    }
    handleAnnualIncomeChange(isFocus, event){
        var amount = this.unFormatAmount(event.target.value);
        if (this.validations.isValidInteger(amount, false)) {
            this.props.onIncomeChange(amount, true);
            this.setState({ anualIncomeDisplay: amount});      
            if(this.props.iframeVersion) {
                try {
                    window.parent.postMessage('ScrollToTop', `${window.iframeHost}`);
                } catch (error) {
                    console.log(error);
                }
            } 
            else {
                // window.scroll(0, 0);
            }
        }
    }

    handleLoanAmountMouseMove(event) {
        var amount = this.unFormatAmount(event.target.value); // event.target.value.replace('$', '').replace(/,/g, '');
        if (this.validations.isValidInteger(amount)) {
            this.setState({ loanAmountDisplay: this.validations.amountFormatting(amount) });
            if (this.state.isLoanAmountRange || this.state.isLoanTermInRange || this.state.isAnualIncomeInRange || this.state.isValidZip || this.state.isLoanTermRange) {
                this.setState({ isUpdateError: true });
            } else {
                this.props.onLoanAmountChange(amount, true);
                if(!window.mobileDevice) this.showFilter(!this.state.displayFilter);
                this.setState({ filterHeader: 'Refine Results', filterButtonText: 'Update Results' });
            }
            if (this.validations.isLoanAmountInRange(amount)) {
                this.setState({ isLoanAmountRange: true, isError: true, loanAmountHasError: true });
            }
            else { this.setState({ isLoanAmountRange: false, isError: false, isUpdateError: false, loanAmountHasError: false }); }
        }
    }

    onLoanPurposeClick(event) {
        this.setState((prevState) => ({ displayLoanPurposeItems: !prevState.displayLoanPurposeItems }));
    }

    handleLoanPurposeChange(event) {
        const loanPurpose = event.target.value; //event.target.attributes['react-value'].value;
        this.setState({ loanPurpose: loanPurpose });
       
        if (this.state.isLoanAmountRange || this.state.isLoanTermInRange || this.state.isAnualIncomeInRange || this.state.isValidZip || this.state.isLoanTermRange) {
            this.setState({ isUpdateError: true });
            this.props.onLoanPurposeChange(loanPurpose, false);
        } else {
            this.props.onLoanPurposeChange(loanPurpose, true);
            if(!window.mobileDevice) this.showFilter(!this.state.displayFilter);
            this.setState({ filterHeader: 'Refine Results', filterButtonText: 'Update Results' });
        }
    }
    handleStateListChange(event){
        const lenderState = event.target.value;
        this.setState({ lenderState: lenderState });
        this.props.onLenderStateChange(lenderState, true);
    }

    onCreditScoreClick(event) {
        this.setState((prevState) => ({ displayCreditScoreItems: !prevState.displayCreditScoreItems }));
    }

    handleCreditScoreChange(event) {
        const creditScore = event.target.value; // event.target.attributes['react-value'].value;
        this.setState({ creditScore: creditScore });
        if (this.state.isLoanAmountRange || this.state.isLoanTermInRange || this.state.isAnualIncomeInRange || this.state.isValidZip || this.state.isLoanTermRange) {
            this.setState({ isUpdateError: true });
        } else {
            this.props.onCreditScoreChange(creditScore, true);
            if(!window.mobileDevice) this.showFilter(!this.state.displayFilter);
            this.setState({ filterHeader: 'Refine Results', filterButtonText: 'Update Results' });
        }
    }

    showFilter = (status) => {
        this.setState({ displayFilter: status, filterToggleClass: status ? '' : 'accordion-toggle' });
    }

    showHideList(isDisplay) {
        return isDisplay ? displayBlock : displayNone;
    }

    getLoanPurposeLabel(key) {
        const selectedLoanPurpose = loanPurposeList.filter((loanPurpose) => {
            return loanPurpose.key === key;
        });
        return selectedLoanPurpose[0].label;
    }

    getCreditScoreLabel(key) {
        const selectedCreditScore = creditScoreList.filter((creditScore) => {
            return creditScore.key === key;
        });
        return selectedCreditScore[0].label;
    }
    render() {
        const toggleIcon = this.state.displayFilter ?
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="10" />
                    <path d="M12 8l4 4-4 4" />
                </svg>
      
            : 
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="10" />
                    <path d="M16 12l-4 4-4-4" />
                </svg>;
        return (          
            <div>
                <div className={`col-lg-12 col-md-12  col-sm-12 col-xs-12 filterHeight `}>
                    <div className="row">                     
                        <div className={`col-lg-3 col-md-3 col-sm-4 col-xs-12 leftpanel  `}>
                            <div className="formlist2 loanAmount-group">
                                <div>
                                    <h4 className="filter-title">Loan Amount</h4>
                                </div>
                                <div className="loanAmountInput">
                                    <span className="input-group-text" id="basic-addon1">{'$'}</span>
                                    <input  placeholder={`${window.currencySymbol}0`} id='rngloanamount' name='rngloanamount'
                                        onChange={this.handleLoanAmountValueChange.bind(this, true)}
                                        onBlur={this.handleLoanAmountValueChange.bind(this, false)} 
                                        value={`${window.currencySymbol}${this.validations.amountFormatting(this.state.loanAmountDisplay)}`}
                                        // `${window.currencySymbol}${this.validations.amountFormatting(amount)}`
                                        className={`form-control loanAmountInputBox ${this.state.showLoanAmountError ? '' : ''}`} />
                                </div>
                            </div>
                        </div>
                        <div className={`col-lg-3 col-md-3 col-sm-4 col-xs-12 leftpanel  `}>
                            <div className="form-group ">
                                <h4 className="filter-title">Credit Score</h4>                        
                                <select  className= {`loan-app form-control form-group `}
                                    value={this.state.creditScore}
                                    onChange={this.handleCreditScoreChange}
                                    id={`creditscore`} name={`creditscore`} >
                                    {creditScoreList.map(element => {
                                        return <option key={element.key} rel={element.index}
                                            value={element.key} id={element.key} name={element.key}>
                                            {element.label}
                                        </option>
                                    })}
                                </select>
                            </div>
                        </div>
                        <div className={` clearfix ${ ' leftpanel col-lg-3 col-lg-offset-3 col-md-3 col-md-offset-3 col-sm-4 col-xs-12  producttypeSortby'} `}>
                            <div className={`form-group`}>
                                <h4 className="filter-title">Sort by:</h4>
                                <select tabIndex={this.props.tabIndex} className= {`loan-app form-control form-group `}
                                    onFocus={this.props.onSortByClick}
                                    onChange={this.handleSortByChange}                                
                                    value={this.props.sortByValue}
                                    id={`sortby`}
                                    name={`sortby`} >
                                    { sortByOfferList1.map(element => {
                                            return <option key={element.key}
                                                value={element.key}>
                                                {element.label}
                                            </option>
                                        }) 
                                    }            
                                </select>                    
                            </div>                      
                        </div>
                    </div>
                </div> 
            </div> 
        );
    }
}

export default FilterGroupContentV2;


// WEBPACK FOOTER //
// ./src/FilterGroupContentV2.js